import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const RegularAmexFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16 5H4.00002C3.26364 5 2.66669 5.59695 2.66669 6.33333V14.3333C2.66669 15.0697 3.26364 15.6667 4.00002 15.6667H16C16.7364 15.6667 17.3334 15.0697 17.3334 14.3333V6.33333C17.3334 5.59695 16.7364 5 16 5Z"
        stroke={theme.colors.neutrals.c400}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.57471 9.08008L4.81055 12H4.05615L5.16699 8.44531H5.63818L5.57471 9.08008ZM6.17773 12L5.40869 9.08008L5.33789 8.44531H5.81641L6.93701 12H6.17773ZM6.20459 10.6743V11.2676H4.60059V10.6743H6.20459ZM7.53027 8.44531H8.15771L8.88281 10.877L9.60547 8.44531H10.1597L9.14893 12H8.61426L7.53027 8.44531ZM7.27637 8.44531H7.87451L7.96729 10.7891V12H7.27637V8.44531ZM9.88623 8.44531H10.4868V12H9.79834V10.7891L9.88623 8.44531ZM13.1089 11.4092V12H11.5635V11.4092H13.1089ZM11.7856 8.44531V12H11.0703V8.44531H11.7856ZM12.9014 9.88574V10.4595H11.5635V9.88574H12.9014ZM13.104 8.44531V9.03857H11.5635V8.44531H13.104ZM14.1562 8.44531L14.6641 9.63184L15.1475 8.44531H15.936L15.0791 10.2056L15.9531 12H15.1328L14.6274 10.7866L14.1221 12H13.3188L14.2075 10.1909L13.3384 8.44531H14.1562Z"
        fill={theme.colors.neutrals.c400}
        stroke="none"
      />
    </svg>
  );
};

export default RegularAmexFilterIcon;
